import { ArrowRight, Box, Layers, Cpu, Hand } from "lucide-react";

export interface CategoryInfo {
  title: string;
  slug: string;
  description: string;
  icon: any;
  gradient: string;
  borderColor: string;
  cardIndices: number[];
}

export const categories: CategoryInfo[] = [
  {
    title: "AR Experiences",
    slug: "ar-experiences",
    description:
      "Augmented reality solutions that overlay digital content onto the real world — from interactive mirrors and immersive invitations to location-based AR activations.",
    icon: Layers,
    gradient: "from-blue-500/20 via-indigo-500/10 to-purple-500/20",
    borderColor: "border-blue-500/20",
    cardIndices: [0, 1],
  },
  {
    title: "VR Experiences",
    slug: "vr-experiences",
    description:
      "Fully immersive virtual reality environments for training, product visualization, architectural walkthroughs, and interactive storytelling.",
    icon: Box,
    gradient: "from-emerald-500/20 via-teal-500/10 to-cyan-500/20",
    borderColor: "border-emerald-500/20",
    cardIndices: [3, 4, 5, 6],
  },
  {
    title: "AI Innovations",
    slug: "ai-innovations",
    description:
      "Intelligent systems powered by machine learning and artificial intelligence — from personalized welcome experiences to smart automation and real-time data processing.",
    icon: Cpu,
    gradient: "from-amber-500/20 via-orange-500/10 to-red-500/20",
    borderColor: "border-amber-500/20",
    cardIndices: [2],
  },
  {
    title: "Immersive Technology",
    slug: "immersive-technology",
    description:
      "Cutting-edge spatial computing and mixed reality solutions that blend digital and physical worlds for unforgettable audience engagement.",
    icon: Hand,
    gradient: "from-fuchsia-500/20 via-pink-500/10 to-rose-500/20",
    borderColor: "border-fuchsia-500/20",
    cardIndices: [9],
  },
  {
    title: "Projection & Animation",
    slug: "projection-animation",
    description:
      "High-impact 3D projection mapping, cinematic animation, and motion graphics that transform any surface into a dynamic visual experience.",
    icon: Layers,
    gradient: "from-violet-500/20 via-purple-500/10 to-indigo-500/20",
    borderColor: "border-violet-500/20",
    cardIndices: [7],
  },
  {
    title: "Software Technology",
    slug: "software-technology",
    description:
      "Intelligent software solutions, IoT automation, and smart systems that optimize operations and enhance digital capabilities.",
    icon: ArrowRight,
    gradient: "from-slate-500/20 via-gray-500/10 to-zinc-500/20",
    borderColor: "border-slate-500/20",
    cardIndices: [8],
  },
];
